import React from 'react'
// import term from 'terminal-kit'/
import SideBar from '../components/sidebar/Sidebar'
import Terminal from '../components/terminal/Terminal'

const Dashboard = () => {
  return <SideBar><Terminal /></SideBar>
}

export default Dashboard